import React from 'react';

function Toast(props){
  return(
    <span className={props.type + " e-toast"}>{props.data}</span>
  );
}
export default Toast;